import React from "react";
// import { UserContext } from "./hooks/UserContext";


import { BrowserRouter, Switch,HashRouter} from 'react-router-dom';
import User from '../Pages/User';
import Transaction from '../Pages/Transaction';
import dash from '../Pages/Dashboard';
import Destination from '../Pages/DestinationList';
import AddDestination from '../Pages/Destination';
import Login from '../Pages/Login';
import NotFound from '../Pages/NotFound';
import MyProfile from '../Pages/Auth/MyProfile';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import UserTripList from '../Pages/UserTripsList';
import EditDestination from '../Pages/EditDestination';
import FlightBooking from "../Pages/FlightBooking";
import HotelBooking from "../Pages/HotelBooking";
import FlightDetail from '../Pages/FlightDetail';
import Commision from "../Pages/Commision";


export default function Router(){

    return (
      <HashRouter basename="/">
      <Switch>
          {/* <Route exact path='/Login' component={Login} /> */}
          {/* PUBLIC ROUTE */}
          <PublicRoute restricted={true} exact path='/Login' component={Login} />
          {/* Private Route */}
          
          <PrivateRoute exact path='/' component={dash} />
          <PrivateRoute exact path='/dashboards' component={dash} />
          <PrivateRoute exact path='/transaction' component={Transaction} />
          <PrivateRoute exact path='/user' component={User} />
          <PrivateRoute exact path='/trip' component={Destination} />
          <PrivateRoute exact path='/flight' component={FlightBooking} />
          <PrivateRoute exact path='/hotel' component={HotelBooking} />
          <PrivateRoute exact path='/trip/create' component={AddDestination} />
          <PrivateRoute exact path='/admin/profile' component={MyProfile} />
          <PrivateRoute exact path='/user/trip/:id' component={UserTripList} />
          <PrivateRoute exact path='/trip/edit/:id' component={EditDestination} />
          <PrivateRoute exact path='/flight/detail' component={FlightDetail} />
          <PrivateRoute exact path='/setting/commission' component={Commision} />
          <PrivateRoute component={NotFound}/>
          {/* <Route exact path='/admin/changePassword' component={ChangePassword} /> */}
        </Switch>
      </HashRouter>
      
      
    );
}




// WEBPACK FOOTER //
// ./src/Route/index.js